/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */



import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Tokens } from './token.model';
import { Injectable, Injector } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CommonConstants } from '../../common/constants/common-constants';
import { map } from 'rxjs/operators';
declare var $: any;

@Injectable()
export class TokenService {

    refresh = false;
    tokenPromise;
    constructor(public injector: Injector) {
    }

    public getToken(): string | Promise<string> {
        const jwtHelper = new JwtHelperService();

        let token = localStorage.getItem('token');
        let refreshToken = localStorage.getItem('refreshToken');

        if (!token || !refreshToken) {
            return null;
        }
        try {
            if (jwtHelper.isTokenExpired(token)) {
                if (jwtHelper.isTokenExpired(refreshToken)) {
                    $('.modal').modal('hide');
                    return null;
                } else {
                    if (!this.refresh) {
                        this.refresh = true;
                        this.tokenPromise = this.promiseFromObservable(this.getTokenService(localStorage.getItem('refreshToken')))
                            .catch(() => {
                                return false;
                            });
                    }
                    return this.tokenPromise;
                }
            } else {
                return token;
            }
        } catch (error) {
            return null;
        }
    }

    getTokenService(refreshToken: string) {
        let http = this.injector.get(HttpClient);

        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + refreshToken
            })
        };
        return http.post<Tokens>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/auth/tokens', null, httpOptions).pipe(map(
            (token: Tokens) => {
                localStorage.setItem('token', token.token);
                localStorage.setItem('refreshToken', token.refreshToken);
                this.refresh = false;
                return token.token;
            }
        ));
    }

    promiseFromObservable(o): Promise<string> {
        return o.toPromise();
    }

}
